import { createContext } from 'react';

let siteData = { authenticityToken: '' };
if (typeof window !== 'undefined') {
  const bodyAttr = document.getElementById('siteBody');
  siteData = JSON.parse(bodyAttr.getAttribute('data-variables'));
}
export const AppVariables = createContext(siteData);
